import { SUPPORT_EMAIL_ADDRESS } from '@frontend/constants';
import type { CommonModalProps } from '@frontend/web-react';
import { Button, Modal, Text, YStack } from '@frontend/web-react';

type ReactivationModalProps = CommonModalProps & {
  hasError?: boolean;
  isLoading?: boolean;
  onContinue: () => void;
};

export const ReactivationModal = ({ hasError, isLoading, isOpen, onClose, onContinue }: ReactivationModalProps) => {
  return (
    <Modal
      closeOnClickOutside={false}
      closeOnEscape={false}
      isOpen={isOpen}
      onClose={onClose}
      size="500px"
      title={hasError ? '⚠️ Hmm, we hit a snag.' : 'Welcome Back'}
      trapFocus
      withCloseButton={false}
      withOverlay
    >
      <YStack gap="lg">
        {hasError ? (
          <>
            <Text type="p-md">Something went wrong while reactivating your account.</Text>
            <Text type="p-md">
              Please try again in a moment - or email {SUPPORT_EMAIL_ADDRESS} and we’ll take care of it.
            </Text>
          </>
        ) : (
          <>
            <Text type="p-md">{`We've`} made some updates around here.</Text>
            <Text type="p-md">
              Jump in and create a task - or five! {`You'll`} be able to pick a plan when a task needs a human
              specialist, or keep rolling on A La Carte for now.
            </Text>

            <Text type="p-md">Have questions? Shoot us a note at {SUPPORT_EMAIL_ADDRESS}</Text>
          </>
        )}

        <Button accessibilityLabel={hasError ? 'Try again' : 'Continue'} fullWidth isLoading={isLoading} onClick={onContinue} size="lg">
          {hasError ? 'Try Again' : 'Continue'}
        </Button>
      </YStack>
    </Modal>
  );
};
